import PropTypes from 'prop-types';
import React from 'react';
import ProductSummary from 'brastrap/promotional/product-summary/ProductSummary';
import EditorialBlock from 'brastrap/editorial/editorial-block/EditorialBlock';
import Activity, { Loading } from 'brastrap/common/activity/Activity';

const STYLE_PREFIX = 'c-results-list';

const ResultsList = props => {
  let className = STYLE_PREFIX;

  // Assume a grid is being rendered by default
  const itemModifiers = ['block'];

  props.modifiers.forEach(modifier => {
    className += ` ${STYLE_PREFIX}--${modifier}`;

    // If a list is being requested instead of a grid then tell the children to render inline.
    if (modifier === 'inline') {
      itemModifiers[0] = 'inline';
    }
  });

  return (
    <div className={className}>
      {props.isFetching ? (
        <div className="c-results-list__loading">
          <Activity />
          <Loading />
        </div>
      ) : (
        <ol className="c-results-list__items">
          {props.productsOrContentModules.map((productOrContentModule, key) => {
            const isProduct = !!productOrContentModule.styleCode;
            const productSummaryProps = {
              currency: props.currency,
              isFetching: props.isFetching,
              modifiers: itemModifiers,
              rating: null,
              onStyleColourChange: props.onStyleColourChange,
              onStyleColourClick: props.onStyleColourClick,
              onSaveItemPress: props.onSaveItemPress,
              savedItemsMap: props.savedItemsMap,
              collection: props.collection,
            };

            return (
              <li key={key} className="c-results-list__item">
                {isProduct ? (
                  <ProductSummary
                    {...productOrContentModule}
                    {...productSummaryProps}
                    locationAttribute="to"
                    collection={props.collection}
                    pathname={props.pathname}
                  />
                ) : (
                  <EditorialBlock
                    content={productOrContentModule}
                    modifiers={itemModifiers}
                  />
                )}
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
};

ResultsList.propTypes = {
  currency: PropTypes.string,
  isFetching: PropTypes.bool,
  modifiers: PropTypes.array,
  productsOrContentModules: PropTypes.array,
  onStyleColourChange: PropTypes.func,
  onStyleColourClick: PropTypes.func,
  onSaveItemPress: PropTypes.func,
  savedItemsMap: PropTypes.object,
  isLoggedIn: PropTypes.bool,
  collection: PropTypes.string,
  pathname: PropTypes.string,
};

ResultsList.defaultProps = {
  modifiers: ['grid-large'],
  productsOrContentModules: [],
};

export default ResultsList;
